import Kpi from './Kpi';

export default Kpi;
